@if (this.editFlag) {
  <h3>Edit: {{ teamHistory.teamName }}</h3>
}
@if (!this.editFlag) {
  <h3>{{ 'Add Historical Team' | platformLabel }}</h3>
}
<form [formGroup]="historicalTeamForm">
  <div fxLayout="column">
    <div fxLayoutAlign="space-between">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
        <mat-label>{{ 'Team Name' | platformLabel }}</mat-label>
        <input
          matInput
          forbidAngleBrackets
          type="text"
          formControlName="teamName"
        />
        @if (historicalTeamForm.get('teamName').hasError('required')) {
          <mat-error> {{ 'Team Name' | platformLabel }} is required </mat-error>
        }
      </mat-form-field>
    </div>
    <div fxLayoutAlign="space-between">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
        <mat-label>Position Title</mat-label>
        <input
          matInput
          forbidAngleBrackets
          type="text"
          formControlName="positionTitle"
          placeholder="Position Title"
        />
        @if (historicalTeamForm.get('positionTitle').hasError('required')) {
          <mat-error> Position Title is required </mat-error>
        }
      </mat-form-field>
    </div>
    <div fxLayoutAlign="space-between" formGroupName="dateGroup">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
          [errorStateMatcher]="matcher"
        />
        <mat-datepicker-toggle matSuffix [for]="startPicker">
        </mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        @if (dateFormGroup.hasError('startDateBeforeEndDate')) {
          <mat-error> Start date must be before the end date </mat-error>
        }
        @if (dateFormGroup.hasError('nullStartDate')) {
          <mat-error> Start date is required </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
        <mat-label>End Date</mat-label>
        <input
          matInput
          [matDatepicker]="endPicker"
          formControlName="endDate"
          placeholder="End Date"
          [errorStateMatcher]="matcher"
        />
        <mat-datepicker-toggle matSuffix [for]="endPicker">
        </mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        @if (dateFormGroup.hasError('nullEndDate')) {
          <mat-error> End date is required </mat-error>
        }
      </mat-form-field>
    </div>
    <mat-dialog-actions>
      <div>
        @if (this.editFlag) {
          <button
            mat-button
            color="primary"
            [disabled]="!historicalTeamForm.valid"
            (click)="manageHistoricalTeam()"
          >
            UPDATE
          </button>
        }
        @if (!this.editFlag) {
          <button
            mat-button
            color="primary"
            [disabled]="!historicalTeamForm.valid"
            (click)="manageHistoricalTeam()"
          >
            ADD
          </button>
        }
      </div>
      <div>
        <button type="button" mat-button (click)="dialogRef.close()">
          CANCEL
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</form>
